import { Box, Stack, styled } from '@mui/material';

export const StyledSidebarContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  borderWidth: 1,
  borderColor: theme.palette.grey[700],
  width: theme.spacing(56),
  borderRightStyle: 'solid',
  borderBottomStyle: 'none',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    borderStyle: 'none',
  },
}));

export const StyledFormulaContainer = styled(Box)(() => ({
  minHeight: 0,
  flex: 1,
}));

export const StyledWrapper = styled(Stack)(({ theme }) => ({
  width: '100%',
  alignItems: 'center',
  gap: theme.spacing(2),
  padding: theme.spacing(2),
  borderBottom: '1px solid',
  borderColor: theme.palette.grey[700],
  cursor: 'pointer',
}));
